import React, { useContext, useState } from 'react'
import { Icon, Input } from 'antd'
import { AppGridCommonSearchItem } from 'api'
import { AppSelectTree, AppTreeProps } from 'components/AppSelectTree'
import { AppGridSearchContext } from './AppGridSearchContext'
import { AppSearchData, getCommonPlaceholder, getCommonFieldList, getValue } from './AppGridSearchData'

// 项目树查询
interface AppProjectTreeSearchProps extends AppTreeProps {
	keyName: string
	dataType?: string
	field: string
	label?: string
}
export const AppProjectTreeSearch = (props: AppProjectTreeSearchProps) => {
	const { onChange, onSearch } = useContext(AppGridSearchContext)

	const hanldChange = (id: number) => {
		let appSearchData: AppSearchData = {
			keyName: props.keyName,
			field: [props.field],
			value: id.toString(),
			itemType: 'projectFilter',
			dataType: 'number',
			minValue: '',
			maxValue: '',
		}
		onChange(appSearchData)
		onSearch()
	}

	return (
		<div className="app-grid-common-search-item">
			<label className="app-grid-common-search-item-label">{props.label}</label>
			<div className="app-grid-common-search-item-component" style={{ width: 300 }}>
				<AppSelectTree scene={props.scene} onChange={data => hanldChange(data.id)} />
			</div>
		</div>
	)
}

// 普通查询
interface AppGridCommonSearchItemProps {
	commonSearchList: AppGridCommonSearchItem[]
}

export const AppTableCommonSearchItem = (props: AppGridCommonSearchItemProps) => {
	const { onSearch, appSearchDataList, onChange } = useContext(AppGridSearchContext)

	const myChange = (value: string) => {
		let appSearchData: AppSearchData = {
			keyName: 'appGridCommonSearch',
			field: getCommonFieldList(props.commonSearchList),
			value,
			itemType: 'commonSearch',
			dataType: 'string',
			minValue: '',
			maxValue: '',
		}
		onChange(appSearchData)
	}

	return (
		<div className="app-grid-common-search-item">
			<div className="app-grid-common-search-item-component" style={{ width: 310 }}>
				<Input.Search
					value={getValue(appSearchDataList, 'appGridCommonSearch')}
					onChange={e => myChange(e.target.value)}
					placeholder={getCommonPlaceholder(props.commonSearchList)}
					onSearch={(value: string) => onSearch()}
				/>
			</div>
		</div>
	)
}

// 高级查询的搜索展开按钮
export const MoreLink = () => {
	const { handleClickMore, showMore } = useContext(AppGridSearchContext)

	return (
		<div
			className="app-grid-common-search-handler"
			onClick={e => {
				handleClickMore()
			}}
		>
			<span className="mc-filter-handler__filter-btn is-expand">
				<span>{showMore ? '收起筛选' : '展开筛选'}</span>
				<Icon
					type={showMore ? 'up' : 'down'}
					style={{ fontSize: '12px', marginLeft: '3px', lineHeight: '26px' }}
				/>
			</span>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppTableSearch/AppGridCommonSearchItem.tsx